import { render } from "./OrderTableMonitor.vue?vue&type=template&id=89325170"
import script from "./OrderTableMonitor.vue?vue&type=script&lang=js"
export * from "./OrderTableMonitor.vue?vue&type=script&lang=js"

import "./OrderTableMonitor.vue?vue&type=style&index=0&id=89325170&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__